/**
 * Figma → OspIcons mapping (Harness icon audit single source).
 * @see features/20260601-portfolio-insight-onboarding-modal/ICON_AUDIT.md
 */
export const OSP_ICON_CODEPOINT = {
  ed: 60179,
  errorCircle: 60145,
  errorCircleRegular: 60196,
  edgen: 60179, // wordmark — must NOT use for Meet Ed chip
};

/** H5 alert card · Figma `88972:41618` — accent2 red ring + ! */
export const PORTFOLIO_INSIGHT_ALERT_SVG_NAME =
  "error-circle-portfolio" as const;

/** PC notice row · Figma `88100:38276` — accent3 orange solid ! */
export const PORTFOLIO_INSIGHT_NOTICE_SVG_NAME =
  "error-circle-portfolio-notice" as const;

export const PORTFOLIO_INSIGHT_ICON_SPEC = {
  ed: {
    testId: "portfolio-insight-ed-icon",
    chipTestId: "portfolio-insight-ed-chip",
    figmaNodes: ["88972:41482", "88125:5695"],
    ospName: "ed",
    source: "osp-font",
    codepoint: OSP_ICON_CODEPOINT.ed,
    sizePx: 20,
    chipSizePx: 32,
    color: "rgb(3, 98, 99)",
  },
  errorCircleAlert: {
    testId: "portfolio-insight-error-icon-card",
    figmaNode: "88972:41618",
    ospName: PORTFOLIO_INSIGHT_ALERT_SVG_NAME,
    expectedVariant: "alert",
    source: "osp-svg",
    sizePx: 20,
    ringFill: "rgb(168, 45, 45)",
    strokeColor: "rgb(168, 45, 45)",
    forbiddenOspNames: [
      "error-circle",
      "error-circle-regular",
      PORTFOLIO_INSIGHT_NOTICE_SVG_NAME,
    ],
    forbiddenCodepoints: [
      OSP_ICON_CODEPOINT.errorCircle,
      OSP_ICON_CODEPOINT.errorCircleRegular,
    ],
  },
  errorCircleNotice: {
    testId: "portfolio-insight-error-icon-notice",
    figmaNode: "88100:38276",
    ospName: PORTFOLIO_INSIGHT_NOTICE_SVG_NAME,
    expectedVariant: "notice",
    source: "osp-svg",
    sizePx: 20,
    ringFill: "rgb(220, 104, 3)",
    strokeColor: "rgb(220, 104, 3)",
    forbiddenOspNames: [
      "error-circle",
      "error-circle-regular",
      PORTFOLIO_INSIGHT_ALERT_SVG_NAME,
    ],
    forbiddenCodepoints: [
      OSP_ICON_CODEPOINT.errorCircle,
      OSP_ICON_CODEPOINT.errorCircleRegular,
    ],
  },
};
